import { render, staticRenderFns } from "./JobDetails.vue?vue&type=template&id=ae3e43a2"
import script from "./JobDetails.vue?vue&type=script&lang=js"
export * from "./JobDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports